import React from 'react'

import { Tab } from 'components'

import { SearchJobs } from './components'

// import { Container } from './styles';

const QueryJobs: React.FC = () => {
  const tabs = ['Pesquisar']
  const [selectedTab, setSelectedTab] = React.useState(0)
  const handleChange = (_, newValue) => setSelectedTab(newValue)
  return (
    <>
      <Tab tabs={tabs} value={selectedTab} handleChange={handleChange} />
      {selectedTab === 0 && <SearchJobs />}
    </>
  )
}

export default QueryJobs
